import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { IStaticContentfulImages } from 'src/types/contentful';
import QuoteAndAttribution from 'src/app/molecules/QuoteAndAttribution/QuoteAndAttribution';

const EmpifyQuoteAndAttribution = (): JSX.Element => {
  const image = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      avatar: contentfulAsset(contentful_id: { eq: "1WRO2JH0PKEgAMThHxWTCG" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 128)
      }
    }
  `);

  return (
    <QuoteAndAttribution
      quote={{
        text: 'We have a 90% retention rate, 65% of our members are annual members, and from one course alone in our app, we’ve generated over six figures.',
        type: 'heading',
        size: 'lg',
      }}
      attribution={{
        authorName: {
          text: 'Ashley Fox',
          type: 'paragraph',
          size: 'md',
          fontWeight: 'font-weight-semibold',
          lineHeight: 'line-height-text-lg',
        },
        authorTitle: {
          text: 'CEO, Empify',
          type: 'paragraph',
          size: 'md',
        },
        avatarWrapper: {
          imageProps: {
            image: image.avatar.gatsbyImageData,
            alt: 'Avatar',
          },
          maxWidth: 64,
        },
      }}
    />
  );
};

export default EmpifyQuoteAndAttribution;
